import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-610d2969"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "invoice p-4 bg-white w-100",
  id: "invoice"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = {
  class: "font-weight-bold text-uppercase",
  style: {"font-size":"1.75rem"}
}
const _hoisted_6 = { class: "font-weight-normal" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "btn-group mt-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit mr-1" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print mr-1" }, null, -1))
const _hoisted_12 = { class: "row mb-4" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold" }, "De :", -1))
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "col-md-6 text-right" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold" }, "Client :", -1))
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = { class: "table table-bordered" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Désignation"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Quantité"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Prix unitaire"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Montant")
  ])
], -1))
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "text-right" }
const _hoisted_28 = { class: "font-weight-bold" }
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sous-total :", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { class: "font-weight-bold" }
const _hoisted_35 = { class: "text-right mt-5" }
const _hoisted_36 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (_ctx.invoice && _ctx.invoice.seller)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("img", {
            src: _ctx.invoice.seller.logo,
            alt: "Logo",
            height: "100"
          }, null, 8, _hoisted_3), [
            [_vShow, !_ctx.showButtons]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.invoiceTypeLabel), 1),
            _createElementVNode("div", _hoisted_6, " N° " + _toDisplayString(_ctx.invoice.number) + " - " + _toDisplayString(_ctx.invoice.issued_at), 1)
          ], 512), [
            [_vShow, !_ctx.showButtons]
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.showButtons)
              ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                  key: 0,
                  value: _ctx.invoice.seller.website,
                  size: 70
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _hoisted_8,
            (_ctx.showButtons)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.invoice.status == 'Brouillon')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-outline-primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit-invoice')))
                      }, [
                        _hoisted_10,
                        _createTextVNode(" Modifier ")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-dark",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('print-invoice')))
                  }, [
                    _hoisted_11,
                    _createTextVNode(" Imprimer ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.invoice.seller.name), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.invoice.seller.email), 1),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.invoice.seller.phone), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.invoice.client.name), 1),
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.invoice.client.address), 1),
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.invoice.client.phone), 1)
          ])
        ], 512), [
          [_vShow, !_ctx.showButtons]
        ]),
        _createElementVNode("table", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(item.title), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(item.qty), 1),
                _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.formatCurrency(item.price)), 1),
                _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatCurrency(item.qty * item.price)), 1)
              ]))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.description, (section, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "my-3"
          }, [
            _createElementVNode("h6", _hoisted_28, _toDisplayString(section.title), 1),
            _createElementVNode("p", null, _toDisplayString(section.content), 1)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", null, [
            _hoisted_30,
            _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.subtotal)), 1)
          ]),
          (_ctx.options.useTVA)
            ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                _createElementVNode("strong", null, "TVA (" + _toDisplayString(_ctx.invoice.taxes.tva) + "%) :", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.tva)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.options.useTPS)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                _createElementVNode("strong", null, "TPS (" + _toDisplayString(_ctx.invoice.taxes.tps) + "%) :", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.tps)), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.options.useCSS)
            ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                _createElementVNode("strong", null, "CSS (" + _toDisplayString(_ctx.invoice.taxes.css) + "%) :", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.css)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h5", _hoisted_34, "Total : " + _toDisplayString(_ctx.formatCurrency(_ctx.total)), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_35, [
          _createElementVNode("img", {
            src: _ctx.invoice.seller.signature,
            alt: "Signature",
            height: "100"
          }, null, 8, _hoisted_36)
        ], 512), [
          [_vShow, !_ctx.showButtons]
        ])
      ]))
    : _createCommentVNode("", true)
}